type Props = {
  winner?: string;
  text: string;
  amount?: number;
};

const Badge = ({ winner, text, amount }: Props) => {
  return (
    <div className={`badge ${winner ? `badge--${winner}` : ''}`}>
      {text} {amount ? `${amount} BUSD` : null}
    </div>
  );
};

export default Badge;
